module.exports = __webpack_public_path__ + "static/media/logotype.c7b91531.svg";